import templateUrl from './google-map.html';
import head from 'lodash/head';
import last from 'lodash/last';

export const googleMapComponent = {
    bindings: {
        getLocationDetails: '&',
        setRoute: '<',
        routeType: '<',
        latlngDetails: '<',
        getAllRoutes: '&',
        getPrivateTravelDirectionDetails: '&'
    },
    templateUrl,
    controller: class GoogleMapComponent {
        constructor($scope, $timeout, GoogleLocationService, GoogleMapService) {
            'ngInject';

            this.$scope = $scope;
            this.$timeout = $timeout;
            this.googleLocationService = GoogleLocationService;
            this.googleMapService = GoogleMapService;
        }

        $onInit() {
            this.transitProviders = [];
            this.isError = false;
            // Bounds for North America
            this.bounds = new google.maps.LatLngBounds();
            this.strictBounds = new google.maps.LatLngBounds(
                new google.maps.LatLng(28.70, -127.50),
                new google.maps.LatLng(48.85, -55.90)
            );

            this.initMap();
        }

        initMap() {
            let directionsDisplay = new google.maps.DirectionsRenderer({
                suppressMarkers: true,
                preserveViewport: true,
            });
            let directionsService = new google.maps.DirectionsService;
            let map = new google.maps.Map(document.getElementById('map'), {
                zoom: 8,
                center: { lat: 42.5441, lng: -75.9928 }
            });

            this._setMapInstance(map);

            if(this.latlngDetails) {
                switch(this.latlngDetails.type) {
                    case 'area':
                        this._drawArea(map);
                    break;
                    case 'route':
                        this._drawRoute(map,directionsService,directionsDisplay);
                    break;
                    case 'privateTrip':
                        this._drawPrivateTripRoute(map,directionsService,directionsDisplay);
                    break;
                    case 'getPublicRoute':
                        this._getPublicRoutes(map,directionsService,directionsDisplay,this.latlngDetails)
                    break;
                    case 'publicRoutes':
                        this._drawPublicRoutes(map,directionsService,directionsDisplay,this.latlngDetails);
                    break;
                }
            }
        }

        _setMapInstance(map) {
            this.googleMapService.setMapInstance(map);
        }

        drawPolygon(map, { name, latlng, type }) {
            let area = new google.maps.Polygon({
                paths: latlng,
                strokeColor: type === 'county' ? '#e06e27' : '#2662cf',
                strokeOpacity: 0.8,
                strokeWeight: 2,
                fillColor: type === 'county' ? '#e06e27' : '#2662cf',
                fillOpacity: 0.35
            });

            let contentstring = 'County: ' + name;
            let infoWindow = new google.maps.InfoWindow({
                content: contentstring
            });

            google.maps.event.addListener(area, 'mouseover', (event) => {
                addTooltip(event.latLng);
            });

            google.maps.event.addListener(area, 'mouseout', (event) => {
                removeTooltip.call(this, area);
            });

            area.setMap(map);

            function addTooltip(location) {
                infoWindow.setPosition(location);
                infoWindow.open(map, area);
            }

            function removeTooltip() {
                infoWindow.close();
            }
        }

        drawPolyline(map, co_ord) {
            const Polyline = new google.maps.Polyline({
                path: co_ord,
                geodesic: true,
                strokeColor: '#e06e27',
                strokeOpacity: 1.0,
                strokeWeight: 3
            });

            Polyline.setMap(map);
        }

        getRouteConfigObject(stops) {
            let routeConfigObj = {
                origin: head(stops),
                destination: last(stops),
                waypoints: []
            };
            if (stops.length > 2) {
                stops.filter((value, index) => {
                    if (index !== 0 && index !== stops.length - 1) {
                        routeConfigObj.waypoints.push(value);
                    }
                });
            }
            return routeConfigObj;
        }

        addMarker(map, position, icon, details) {
            let marker = new google.maps.Marker({
                position: position,
                map: map,
                icon: icon
            });

            let contentstring = `<div>
                    <h3>${details.name}</h3>
                    <p>${details.description}</p>
                </div>`;

            let infoWindow = new google.maps.InfoWindow({
                content: contentstring
            });

            google.maps.event.addListener(marker, 'mouseover', (event) => {
                addTooltip(event.latLng);
            });

            google.maps.event.addListener(marker, 'mouseout', (event) => {
                removeTooltip();
            });

            function addTooltip(location) {
                infoWindow.setPosition(location);
                infoWindow.open(map, marker);
            }

            function removeTooltip() {
                infoWindow.close();
            }
        }

        getRoute(map, directionsService, directionsDisplay, { origin, destination, waypoints = [] }) {
            let icons = {
                start: new google.maps.MarkerImage('/./images/origin_icon.png'),
                end: new google.maps.MarkerImage('/./images/end-marker.png')
            }

            const routeConfig = {
                origin: origin.latlng,
                destination: destination.latlng,
                travelMode: google.maps.TravelMode["DRIVING"]
            };

            directionsService.route(routeConfig, (resp, status) => {
                directionsDisplay.setDirections(resp);
                this.addMarker(map, origin.latlng, icons.start, origin.details);
                this.addMarker(map, destination.latlng, icons.end, destination.details);
                waypoints.map(point => {
                    this.addMarker(map, point.latlng, icons.start, point.details);
                });
                (this.latlngDetails.type === 'privateTrip') ? this._getPrivateTravelDirectionDetails(head(resp.routes)) : true;
            });
        }

        _getPrivateTravelDirectionDetails({legs, overview_polyline:encodedPolyline}) {
            const details = {
                duration: head(legs).duration,
                distance: head(legs).distance,
                encodedPolyline
            };
            this.getPrivateTravelDirectionDetails({
                $event: details
            });
        }

        _drawArea(map) {
            this.latlngDetails.values.map(value => this.drawPolygon(map, value));
        }

        _drawRoute(map,directionsService,directionsDisplay) {
            this.latlngDetails.values.map(value => {
                if (value.isRouteFixed === "fixed") {
                    value.details.lines.map(line => this.drawPolyline(map, line));
                    value.details.stops.map((stop, index) => {
                        let icon = (index !== value.details.stops.length - 1) ? "/./images/origin_icon.png" : "/./images/end-marker.png";
                        this.addMarker(map, stop.latlng, icon, stop.details);
                    });
                } else if (value.isRouteFixed === "not fixed") {
                    directionsDisplay.setMap(map);
                    let routeDetails = this.getRouteConfigObject(value.details.stops);
                    this.getRoute(map, directionsService, directionsDisplay, routeDetails);
                }
            });
        }

        _drawPrivateTripRoute(map,directionsService,directionsDisplay) {
            const lineSymbol = {
                    path: google.maps.SymbolPath.CIRCLE,
                    fillOpacity: 1,
                    scale: 3
                };

                const polylineDotted = {
                    strokeColor: "#e06e27",
                    strokeOpacity: 0,
                    fillOpacity: 0,
                    icons: [{
                        icon: lineSymbol,
                        offset: '0',
                        repeat: '10px'
                    }],
                };
                directionsDisplay = new google.maps.DirectionsRenderer({
                    suppressMarkers: true,
                    preserveViewport: false,
                    polylineOptions: polylineDotted
                });

                directionsDisplay.setMap(map);
                this.getRoute(map, directionsService, directionsDisplay, this.latlngDetails);
        }

        _getPublicRoutes(map,directionsService,directionsDisplay,{ origin, destination, departAt }) {
            const routeConfig = {
                origin: origin.latlng,
                destination: destination.latlng,
                travelMode: 'TRANSIT',
                transitOptions: {
                    modes: ['BUS'],
                    departureTime: departAt
                },
                provideRouteAlternatives: true
            };

            directionsService.route(routeConfig, (resp, status) => {
                if (status === 'OK') {
                    this.getAllRoutes({
                        $event: resp
                    });
                } else {
                    this.getAllRoutes({
                        $event: {}
                    });
                } 
            })
        }

        _drawPublicRoutes(map,directionsService,directionsDisplay,details) {
            this._placeMarker(map, details);
            this._drawSteps(map, details);
        }

        _placeMarker(map,{ origin, destination, stops }) {
            let icons = {
                start: new google.maps.MarkerImage('/./images/origin_icon.png'),
                end: new google.maps.MarkerImage('/./images/end-marker.png'),
                stop: new google.maps.MarkerImage('/./images/bus_stop.png'),
            };

            this.addMarker(map, origin.latlng, icons.start, origin.details);
            this.addMarker(map, destination.latlng, icons.end, destination.details);

            stops.map(({latlng, details}) => this.addMarker(map, latlng, icons.stop, details));
        }

        _drawSteps(map, {steps}) {
            let polylineConfigObject;
            steps.map(({mode, latlngs}) => {
                polylineConfigObject = this._getPolylineConfigObject(mode, latlngs);
                this._drawRoutePolyline(map, polylineConfigObject);
            });
        }

        _drawRoutePolyline(map, polylineConfigObject) {
            const polyline = new google.maps.Polyline(polylineConfigObject);
            polyline.setMap(map);
            this._zoomToObject(map, polyline);
        }

        _zoomToObject(map, polyline){
            let points = polyline.getPath().getArray();
            points.map(point => this.bounds.extend(point));
            map.fitBounds(this.bounds);
        }

        _getPolylineConfigObject(travelMode, latlngs) {
            switch (travelMode) {
                case 'WALKING':
                    let lineSymbol = {
                        path: 'M 0,-1 0,1',
                        strokeOpacity: 1,
                        scale: 3
                    };
                    return {
                        path: latlngs,
                        strokeOpacity: 0,
                        strokeColor: '#000',
                        icons: [{
                            icon: lineSymbol,
                            offset: '0',
                            repeat: '10px'
                        }],
                    };
                case 'DRIVING':
                    let drivingLineSymbol = {
                        path: 'M 0,-1 0,1',
                        strokeOpacity: 1,
                        scale: 3
                    };
                    return {
                        path: latlngs,
                        strokeOpacity: 0,
                        strokeColor: '#366DA8',
                        icons: [{
                            icon: drivingLineSymbol,
                            offset: '0',
                            repeat: '10px'
                        }],
                    };
                default:
                    return {
                        path: latlngs,
                        geodesic: true,
                        strokeColor: '#e06e27',
                        strokeOpacity: 1.0,
                        strokeWeight: 5,
                    }
            };
        }

        $onChanges(changes) {
            this.$onInit();
        }
    }
};


// WEBPACK FOOTER //
// ./src/app/common/components/google-map/google-map.component.js